import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from '@infrastructure/domain';
import type * as Types from '@interfaces/xingOne';
import { SlugOrID } from '@domain/scalars';

export type XingId = Types.XingId;
export type ProfileImageX1 = Types.ProfileImage;
export type ProfileImageSizeX1 = Types.ProfileImageSize;
export type OccupationX1 = Types.XingIdOccupation;
export type OccupationCategoryX1 = Types.XingIdOccupationCategory;
export type XingUserX1 = Pick<XingId, 'id' | 'firstName' | 'lastName' | 'displayName' | 'occupations' | 'profileImage' | 'pageName'>;

class ProfileImage implements ProfileImageX1 {
  @Expose()
  url: Types.Maybe<string>;

  @Expose()
  size: Types.Maybe<ProfileImageSizeX1>;
}

class Occupation implements OccupationX1 {
  @Expose()
  category: Types.Maybe<OccupationCategoryX1>;

  @Expose()
  summary: Types.Maybe<string>;

  @Expose()
  headline: Types.Maybe<string>;

  @Expose()
  subline: Types.Maybe<string>;
}

export class XingUser implements XingUserX1 {
  static fromData(data: Subset<XingUserX1>): XingUser | null {
    if (!data || !data.id) {
      return null;
    }

    return plainToInstance(XingUser, data);
  }

  toData(): Record<string, any> {
    return instanceToPlain<XingUser>(this);
  }

  @Expose()
  id: SlugOrID;

  @Expose()
  firstName: Types.Maybe<string>;

  @Expose()
  lastName: Types.Maybe<string>;

  @Expose()
  displayName: Types.Maybe<string>;

  @Expose()
  pageName: Types.Maybe<string>;

  @Expose()
  @Type(() => ProfileImage)
  profileImage?: Types.Maybe<ProfileImage[]>;

  @Expose()
  @Type(() => Occupation)
  occupations?: Types.Maybe<Array<Types.Maybe<Occupation>>>;
}
